<template>
  <div class="paike-err" data-test="paike-err">
    <div class="err-body">
      <div class="top-tips">
        <van-icon name="warning-o" size="var(--fs-md)" style="margin-right: calc(var(--gap) * 8);" />
        <span v-if="type === 'reOpen'">
          <span v-if="hasCurrentClassConflict">
            新排课与同班级的其它排课存在冲突;
          </span>
          <span v-else>
            新排课与其他排课存在冲突
          </span>
        </span>
        <span v-else>
          新排课与其他排课存在冲突{{hasCurrentClassConflict? '，存在同班级冲突请返回修改；': ';'}}
        </span>
        
      </div>
      <van-collapse class="err-main" accordion v-model="active">
        <!-- 老师冲突 -->
        <van-collapse-item
          v-for="ti1 in teacherErrs"
          :key="ti1.teacherId"
          :name="ti1.teacherId"
        >
          <template #title>
            <div style="position:relative;">{{ti1.teacherName}}<span class="small-tips">老师</span></div>
          </template>
          <template #value>
            <div class="err-value">
              <span class="err-times">{{ti1.courseArrangeCount}}</span>次排课冲突
            </div>
          </template>

          <template #default>
            <div class="err-content" v-for="(ti2, i2) in ti1.conflictList" :key="i2">
              <div class="cur-flag" v-if="ti2.currentClass">当前班级</div>
              <div class="el1" v-if="ti2.conflictItemType">
                {{ ti2.curriculumName }}
              </div>
              <div class="el1" v-else>
                {{ ti2.className }}
              </div>
              <div
                class="el2"
                v-for="(ti3, i3) in ti2.timeRangeList"
                :key="i3"
              >
                {{ ti3.startTime | formatDatetime("yyyy-MM-dd") }}
                {{ ti3.startTime | getWeek }}
                {{ ti3.startTime | formatDatetime("hh:mm") }}-{{
                  ti3.endTime | formatDatetime("hh:mm")
                }}
              </div>
            </div>
          </template>
        </van-collapse-item>

        <!-- 教室冲突 -->
        <van-collapse-item
          v-for="ritem in roomErr"
          :key="ritem.classRoomId"
          :name="ritem.classRoomId"
        >
          <template #title>
            <div style="position:relative;">{{ritem.classRoomName}}<span class="small-tips">教室</span></div>
          </template>
          <template #value>
            <div class="err-value">
              <span class="err-times">{{ ritem.courseArrangeCount }}</span
              >次排课冲突
            </div>
          </template>

          <template #default>
            <div
              class="err-content"
              v-for="(item, index) in ritem.conflictList"
              :key="index"
            >
              <div class="cur-flag" v-if="item.currentClass">当前班级</div>
              <div class="el1" v-if="item.conflictItemType">
                {{ item.curriculumName }}
              </div>
              <div class="el1" v-else>
                {{ item.className }}
              </div>
              <div
                class="el2"
                v-for="(sub, sindex) in item.timeRangeList"
                :key="sindex"
              >
                {{ sub.startTime | formatDatetime("yyyy-MM-dd") }}
                {{ sub.startTime | getWeek }}
                {{ sub.startTime | formatDatetime("hh:mm") }}-{{
                  sub.endTime | formatDatetime("hh:mm")
                }}
              </div>
            </div>
          </template>
        </van-collapse-item>
      </van-collapse>
    </div>

    <div class="btns">
      <van-button 
        square round 
        type="default" 
        @click="goPaike" 
        data-test="paike-err-btn-ignore"
        v-if="!hasCurrentClassConflict">
        忽略冲突，{{type === 'reOpen'? '恢复' : '继续'}}排课
      </van-button>
      <van-button 
        square round 
        type="primary" 
        @click="goBack" 
        data-test="paike-err-btn-back">
        {{type === 'reOpen'? '取消恢复' : '返回修改'}}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: "排课冲突",
      active: ["1"],
      teacherErrs: [],
      roomErr: [],
      type: this.$vxRoute.query.type,
    };
  },
  computed: {
    // 判断是否存在当前班级冲突
    hasCurrentClassConflict () {
      let  { teacherErrs, roomErr } = this;
      if (!teacherErrs.length && !roomErr.length) return false;
      for (let err of this.roomErr) {
        for (let conflict of err.conflictList||[]) {
          if (conflict.currentClass) return true;
        }
      }
      for (let err of this.teacherErrs) {
        for (let conflict of err.conflictList||[]) {
          if (conflict.currentClass) return true;
        }
      }
      return false
    }
  },
  methods: {
      goPaike() {
        app.vue.$emit("class-paike-continue")
        this.$router.back()
      },
      goBack() {
        this.$router.back()
      }
  },
  created() {
    let errs = window.__paikeErrData__;
    if (errs) {
      this.teacherErrs = errs.teacherConflictList;
      this.roomErr = errs.classRoomConflictList;
    }
  },
};
</script>

<style lang="scss" scoped>
.paike-err {
  display: flex;
  flex-direction: column;
  .err-body {
    flex: 1;
    overflow: auto;
    .top-tips {
      position: relative;
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16) calc(var(--gap) * 12) calc(var(--w) * 32);
      color: var(--c3);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      background: rgba(238, 10, 36, 0.04);
      .van-icon-warning-o{
        position: absolute;
        left: calc(var(--gap) * 15);
        top: calc(var(--gap) * 14);
      }
    }
    .err-main {
      .small-tips {
        position: absolute;
        top: calc(var(--w) * -10);
        right: calc(var(--w) * -30);
        background: var(--c1);
        font-size: var(--fs-sm);
        border-radius: calc(var(--w) * 8) calc(var(--w) * 8) calc(var(--w) * 8) 0px;
        padding: 0 calc(var(--gap) * 6);
        line-height: var(--lh-sm);
        color: var(--white);
      }
      ::v-deep .van-cell__title {
        flex: auto;
        flex-grow: 0;
        flex-shrink: 0;
        margin-right: calc(var(--gap) * 20);
      }
      .err-value {
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        .err-times {
          color: var(--c3);
        }
      }
      .err-content {
        position: relative;
        margin-top: calc(var(--gap) * 8);
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
        background: var(--g1);
        border-radius: var(--radius-base);
        // border-radius: 4px;
        &:first-child {
          margin-top: 0;
        }
        .cur-flag {
          position: absolute;
          top: 0;
          right: 0;
          padding-left: calc(var(--gap) * 8);
          padding-right: calc(var(--gap) * 8);
          height: var(--lh-sm);
          font-size:var(--fs-sm);
          line-height:var(--lh-sm);
          color: var(--c1);
          background:var(--g3);
          border-top-right-radius: var(--radius-base);
          border-bottom-left-radius: var(--radius-base);
        }
        .el1 {
          color: var(--g8);
          font-size: var(--fs-md);
          line-height: var(--lh-md);
        }
        .el2 {
          margin-top: calc(var(--gap) * 8);
          color: var(--g6);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
        }
      }
    }
  }
  .btns {
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    background: var(--white);
    .van-button {
      flex: 1;
      margin-left: 12px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
